import routerOptions0 from "/srv/projects/www.kliniken-delitzsch-eilenburg.de/public/node_modules/.pnpm/nuxt@4.6.1_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7_supports-color@10.2.2___@_e860a9a38537f0d3c02223369ac39568/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/srv/projects/www.kliniken-delitzsch-eilenburg.de/public/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto",
  sensitive: true
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}